<script>
import { useAppDataStore } from '../stores/appDataStore';
import { computed } from 'vue';

export default {
  components: {},
  props: {},
  setup() {
    const appDataStore = useAppDataStore();
    const appData = computed(() => appDataStore.appData);
    const updateOrderType = (value) => {
      appData.value.orderType = value;
      appData.value.contact.termin_select = false;
    }

    const getPrice = () => {
      const partnerTarifPrice = 10.00;

      if (appData.value.partnertarif) {
        return (appData.value.s5.userSelectedPrice + partnerTarifPrice).toFixed(2);
      }

      return appData.value.s5.userSelectedPrice.toFixed(2);
    }

    return {
      appData,
      updateOrderType,
      getPrice
    }
  }
}

</script>

<template>
  <div class="online-order-wrapper">
    <button
      :class="{'online-order-button-active': appData.orderType === 'Unverbindliche Anfrage'}"
      class="online-order-button online-order-left"
      @click="updateOrderType('Unverbindliche Anfrage')">
      <i class="icon icon--info"></i>
      <span>Unverbindlich anfragen</span>
    </button>
    <button
      :class="{'online-order-button-active': appData.orderType === 'Online Bestellung'}"
      class="online-order-button online-order-right"
      @click="updateOrderType('Online Bestellung')">
      <i class="icon icon--cart-shopping"></i>

      <span>Online bestellen (
        <span>
          {{ getPrice() }}
        </span>
        € / Mon.)
      </span>

    </button>
  </div>
</template>

<style lang="scss" scoped>

</style>
